import React, { PropTypes } from 'react';
import { queryString } from 'lib/format';

const shareBaseUrl = 'https://twitter.com/intent/tweet';

const TwitterShare = ({ appBaseUrl, content, currentUrl }) => {
    const { id, name: text } = content;
    const query = queryString({
        lang: 'en',
        original_referer: currentUrl,
        text,
        url: `${appBaseUrl}?id=${id}`
    }, true);
    const shareUrl = `${shareBaseUrl}${query}`;

    return (
        <a
            className="btn-social sm icon-font-before icon-twitter-solid-before"
            data-notrack="true"
            data-route="false"
            href={shareUrl}
        />
    );
};

TwitterShare.propTypes = {
    appBaseUrl: PropTypes.string,
    content: PropTypes.object,
    currentUrl: PropTypes.string
};

export default TwitterShare;



// WEBPACK FOOTER //
// ./app/common/social/TwitterShare.js